var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoldbricksvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55336 10.826L6.5528 10.8255L6.54998 10.8238L6.55336 10.826ZM17.2515 9.05586L16.0101 5.77142L11.4977 3.31836L2.14673 8.30267L0.779297 11.9561L6.2918 14.889L6.38236 10.9138L2.09386 8.46523L2.46173 8.65986L2.25192 8.53892L3.00117 8.93717L2.31942 8.53892L6.5528 10.8255L15.6681 6.11398L14.209 6.91498L15.9173 6.04255L12.5361 7.83298L6.66699 11.0544L6.29123 14.8884L17.251 9.05473L17.2515 9.05586ZM6.73561 9.67911L4.2668 8.36173L6.66811 9.10423L14.02 5.84173L6.73561 9.67911Z",
    fill: "#A36E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldbricksvg);
export default __webpack_public_path__ + "static/media/goldbricksvg.7987c56745bb0ee86de80128eff6f3c6.svg";
export { ForwardRef as ReactComponent };